import template from './print_deposit_packing.html';
import controller from './print_deposit_packing.controller';
import './print_deposit_packing.scss';

let printDepositPackingComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default printDepositPackingComponent;


// WEBPACK FOOTER //
// ./client/app/components/deposit_packing/print/print_deposit_packing.component.js